import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleEyesYeux10 = customSolarIconWrapper(<g transform="translate(84 109)">
	<path d="M54.2998 30C61.4795 30 67.2998 24.1797 67.2998 17C67.2998 9.8203 61.4795 4 54.2998 4C47.1201 4 41.2998 9.8203 41.2998 17C41.2998 24.1797 47.1201 30 54.2998 30Z" stroke="#202020" strokeWidth="8" />
	<path d="M17 34C24.1797 34 30 28.1797 30 21C30 13.8203 24.1797 8 17 8C9.8203 8 4 13.8203 4 21C4 28.1797 9.8203 34 17 34Z" stroke="#202020" strokeWidth="8" />
	<path d="M54.2998 15.5C57.0612 15.5 59.2998 13.2614 59.2998 10.5C59.2998 7.73858 57.0612 5.5 54.2998 5.5C51.5384 5.5 49.2998 7.73858 49.2998 10.5C49.2998 13.2614 51.5384 15.5 54.2998 15.5Z" fill="#202020" />
	<path d="M17 19.5C19.7614 19.5 22 17.2614 22 14.5C22 11.7386 19.7614 9.5 17 9.5C14.2386 9.5 12 11.7386 12 14.5C12 17.2614 14.2386 19.5 17 19.5Z" fill="#202020" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleEyesYeux10;
